import useTranslate from 'hooks/useTranslate';
import { Helmet } from 'react-helmet'
import { useNavigate, useParams } from 'react-router-dom'
import { dataLayerPush } from 'utils/Datalayer'
import { useEffect } from 'react'

const NotFound = () => {
	const navigate = useNavigate()
    const {errorStatus} = useParams();
	const {t} = useTranslate()
	const gotoHome = () => {
		navigate('/')
	}
	useEffect(() => {
		dataLayerPush({
			event: "website_error",
			error_type: errorStatus ? errorStatus : '404',
		})
	}, [])
	return (
		<div className='notfound'>
			<Helmet>
				<title>{t('errorStatus')}</title>
			</Helmet>
			<div className='notfound-container'>
				<div className='notfound-container-404'>{errorStatus ? errorStatus : '404'}</div>
				<div className='notfound-container-text'>{errorStatus && errorStatus == 500 ? t('somethingWrong'):t('pageNotFound')}</div>
				<div className='notfound-container-subText'>{errorStatus && errorStatus == 500 ? t('sorrySomethingWrong'):t('sorryPageNotFound')}</div>
				<button onClick={gotoHome} className='notfound-container-button'>
					{t('backToHomeBtn')}
				</button>
			</div>
		</div>
	)
}

export default NotFound
